import { atom } from 'recoil';

//hooks
import { modalOptions } from 'hooks/modal/modalOptions';

export const modalOptionsState = atom({
  key: 'modalOptions',
  default: modalOptions,
});
